export default { sha: '2cacaaeb3baab69c130dcf9cfb66bfce5e734595', buildNumber: 'undefined' }
